module.exports = __webpack_public_path__ + "img/mic.184c58f1.svg";